import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { AppInfoService } from 'core/app-info/app-info.service';
import { AppLocalization } from 'src/app/modules/shared/entities/app-localization';
import { FormBuilder, Validators } from '@angular/forms';
import { LeadNote } from '../../../entities/leadNote';
import { NotesWidgetService } from '../../../notes-widget/notes-widget.service';

@Component({
  selector: 'app-lead-notes',
  templateUrl: './lead-notes.component.html',
  styleUrls: ['./lead-notes.component.scss'],
  standalone: false
})
export class LeadNotesComponent implements OnInit {
  @ViewChild('buttons') buttons: ElementRef;
  appStrings: AppLocalization;
  dateTimeFormat: string;
  form: any;
  isAddNote = false;
  isScrolled = false;
  loading = false;
  @Input() notes: LeadNote[];
  @Input() accountId: string;
  constructor(
    fb: FormBuilder,
    private appInfoService: AppInfoService,
    private notesWidgetService: NotesWidgetService
  ) {
    this.form = fb.group({
      note: ['', Validators.required],
    });
  }

  ngOnInit() {
    this.appStrings = this.appInfoService.appStrings;
    this.dateTimeFormat = this.appInfoService.dateTimeFormat;
  }

  ngAfterViewChecked() {
    if (this.isAddNote && !this.isScrolled) {
      this.buttons.nativeElement.scrollIntoView({ behavior: 'smooth' });
      this.isScrolled = true;
    }
  }

  removeNote(index: number) {
    this.loading = true;
    const currentNote = this.notes[index];
    this.notesWidgetService.deleteAccountsNotes(currentNote.id, currentNote.accountId, true).subscribe(() => {
      this.loading = false;
      this.notes.splice(index, 1);
    });
  }

  toggleAddNote() {
    this.isAddNote = !this.isAddNote;
    this.isScrolled = false;
    this.form.reset();
  }

  addNewNote() {
    this.form.controls.note.markAsTouched();
    const { value, valid } = this.form;
    if (valid) {
      this.loading = true;
      this.notesWidgetService.saveAccountsNotes(this.accountId, value.note, true).subscribe(result => {
        this.loading = false;
        this.isAddNote = !this.isAddNote;
        this.notes.push(
          {
            id: result.entityId,
            noteText: value.note,
            noteDate: result.noteDate,
            accountId: this.accountId,
            author: result.author,
            propagateUpdate: false,
            isPermanent: false
          });
      });
    }
  }
}
